import React, { useEffect, useState } from 'react';
import WizardHeader from './WizardHeader';
import { WizardPageWrapper, Header, RendererWrapper, Footer } from './styles';
import WizardFooter from './WizardFooter';
import CableFlagWizard from './CableFlagWizard/CableFlagWizard';
import { useDispatch } from 'react-redux';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import {
  setModeActionThunk,
  setWizardData,
  createCableFlagSections,
  createSnapshotThunk,
  centerViewbox,
  checkPageContentLength,
  handleSectionClick,
  handleShapeClick,
} from '@/actions';
import { FormattedMessage } from 'react-intl';
import { getAllLayers } from 'pxc-editor-core/helpers/schema';

const WizardModePage = props => {
  const {
    isSmartphone,
    isDesktop,
    targetDevice,
    areSectionsSelected,
    selWizard,
    textTypingResource,
    isSideMenuTabOpen,
    sideBarProps,
    userSizeUnit,
    setIsCableFlagSyncState,
    pages,
    pagesSelection,
  } = props;
  const dispatch = useDispatch();
  const crossSectionAreas = [
    {
      value: 7,
      label: '0,25 mm²/24 AWG',
    },
    {
      value: 8,
      label: '0,50 mm²/21 AWG',
    },
    {
      value: 9,
      label: '0,75 mm²/19 AWG',
    },
    {
      value: 10,
      label: '1,00 mm²/18 AWG',
    },
    {
      value: 11,
      label: '1,50 mm²/16 AWG',
    },
    {
      value: 14,
      label: '2,50 mm²/14 AWG',
    },
    {
      value: 16,
      label: '4,00 mm²/12 AWG',
    },
    {
      value: 20,
      label: '6,00 mm²/10 AWG',
    },
    {
      value: 24,
      label: '10,00 mm²/8 AWG',
    },
    {
      value: 28,
      label: '16,00 mm²/6 AWG',
    },
    {
      value: 35,
      label: '25,00 mm²/4 AWG',
    },
    {
      value: 40,
      label: '35,00 mm²/2 AWG',
    },
    {
      value: 48,
      label: '50,00 mm²/1 AWG',
    },
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const [withMiddleLine, setWithMiddleLine] = useState(
    selWizard?.data?.withMiddleLine || false
  );
  const [lineType, setLineType] = useState(
    selWizard?.data?.lineType || 'dashed'
  );
  const [lineThickness, setLineThickness] = useState(
    selWizard?.data?.lineThickness || 0.5
  );
  const [isDimesionTypeDiameter, setIsDimesionTypeDiameter] = useState(
    selWizard?.data?.hasOwnProperty('isDimesionTypeDiameter')
      ? selWizard.data.isDimesionTypeDiameter
      : true
  );
  const [isFlagLengthAuto, setIsFlagLengthAuto] = useState(
    selWizard?.data?.isFlagLengthAuto || false
  );
  const [textOrientation, setTextOrientation] = useState(
    selWizard?.data?.textOrientation === 'vertical' ? 'vertical' : 'horizontal'
  );
  const [slaveAngle, setSlaveAngle] = useState(
    selWizard?.data?.slaveAngle || 0
  );
  const [flagLength, setFlagLength] = useState(
    selWizard?.data?.flagLength || 25.4
  );
  const [cableDiameter, setCableDiameter] = useState(
    selWizard?.data?.cableDiameter || 6.3
  );
  const [flagMidLength, setFlagMidLength] = useState(
    selWizard?.data?.flagMidLength ||
      (isDimesionTypeDiameter
        ? Math.ceil(cableDiameter * Math.PI)
        : crossSectionAreas[0].value)
  );
  const [isCableFlagSync, setIsCableFlagSync] = useState(
    selWizard?.data?.isCableFlagSync || false
  );
  const [wizardPages, setWizardPages] = useState(selWizard?.data?.pages || {});
  const isLastWizardPage = currentPage > 0;

  useEffect(() => {
    if (selWizard?.data?.withMiddleLine !== withMiddleLine)
      setWithMiddleLine(selWizard?.data?.withMiddleLine);
    if (selWizard?.data?.lineType !== lineType)
      setLineType(selWizard?.data?.lineType);
    if (selWizard?.data?.lineThickness !== lineThickness)
      setLineThickness(selWizard?.data?.lineThickness);
    if (selWizard?.data?.isDimesionTypeDiameter !== isDimesionTypeDiameter)
      setIsDimesionTypeDiameter(selWizard?.data?.isDimesionTypeDiameter);
    if (selWizard?.data?.isFlagLengthAuto !== isFlagLengthAuto)
      setIsFlagLengthAuto(selWizard?.data?.isFlagLengthAuto);
    if (selWizard?.data?.textOrientation !== textOrientation)
      setTextOrientation(selWizard?.data?.textOrientation);
    if (selWizard?.data?.slaveAngle !== slaveAngle)
      setSlaveAngle(selWizard?.data?.slaveAngle);
    if (
      selWizard?.data?.flagLength &&
      selWizard?.data?.flagLength !== flagLength
    )
      setFlagLength(Number(selWizard?.data?.flagLength));
    if (
      selWizard?.data?.cableDiameter &&
      selWizard?.data?.cableDiameter !== cableDiameter
    )
      setCableDiameter(selWizard?.data?.cableDiameter);
    if (
      selWizard?.data?.flagMidLength &&
      selWizard?.data?.flagMidLength !== flagMidLength
    )
      setFlagMidLength(selWizard?.data?.flagMidLength);
    if (selWizard?.data?.isCableFlagSync !== isCableFlagSync)
      setIsCableFlagSync(selWizard?.data?.isCableFlagSync);
    if (selWizard?.data?.pages !== wizardPages)
      setWizardPages(selWizard?.data?.pages);
  }, [selWizard]);

  const setCableDiameterByArea = area => {
    let diameter = 0;
    if (area && !isNaN(area)) {
      diameter = Math.ceil((area / Math.PI) * 1000) / 1000;
      //setCableDiameter(diameter);
      setFlagMidLength(area);
    }
  };

  const onCableDiameterChangeClb = ev => {
    if (ev && !isNaN(ev)) {
      setCableDiameter(ev);
      setFlagMidLength(Math.ceil(ev * Math.PI));
    }
  };

  const onFlagLengthChangeClb = ev => {
    if (ev && !isNaN(ev)) setFlagLength(ev);
  };

  const onLineThicknessChangeClb = ev => {
    if (ev && !isNaN(ev)) setLineThickness(ev);
  };

  const onSaveClick = () => {
    const _wizardPages = {};
    if (wizardPages && Object.keys(wizardPages)?.length) {
      Object.keys(wizardPages).forEach(wp => {
        _wizardPages[wp] = {
          flagLength: flagLength,
        };
      });
    } else if (pages && Object.keys(pages)?.length) {
      Object.keys(pages).forEach(wp => {
        _wizardPages[wp] = {
          flagLength: flagLength,
        };
      });
    }
    const wizardProjectData = {
      withMiddleLine: !!withMiddleLine,
      isDimesionTypeDiameter: !!isDimesionTypeDiameter,
      isFlagLengthAuto: !!isFlagLengthAuto,
      textOrientation: textOrientation,
      slaveAngle: slaveAngle,
      flagLength: flagLength,
      flagMidLength: flagMidLength,
      cableDiameter: cableDiameter,
      isCableFlagSync: !!isCableFlagSync,
      pages: _wizardPages,
    };

    dispatch(setWizardData({ ...selWizard, data: wizardProjectData }));
    dispatch(createCableFlagSections());
  };

  const onEditorClick = () => {
    const _wizardPages = {};
    if (wizardPages && Object.keys(wizardPages)?.length) {
      Object.keys(wizardPages).forEach(wp => {
        _wizardPages[wp] = {
          flagLength: flagLength,
        };
      });
    } else if (pages && Object.keys(pages)?.length) {
      Object.keys(pages).forEach(wp => {
        _wizardPages[wp] = {
          flagLength: flagLength,
        };
      });
    }
    const wizardProjectData = {
      withMiddleLine: !!withMiddleLine,
      lineType,
      lineThickness,
      isDimesionTypeDiameter: !!isDimesionTypeDiameter,
      isFlagLengthAuto: !!isFlagLengthAuto,
      textOrientation: textOrientation,
      slaveAngle: slaveAngle,
      flagLength: flagLength,
      flagMidLength: flagMidLength,
      cableDiameter: cableDiameter,
      isCableFlagSync: !!isCableFlagSync,
      pages: _wizardPages,
    };
    selWizard['data'] = wizardProjectData;
    dispatch(setWizardData(selWizard));
    dispatch(setModeActionThunk(INTERACTION_MODE.EDIT));
    dispatch(createCableFlagSections());

    if (pages && Object.keys(pages)?.length) {
      dispatch(checkPageContentLength(Object.keys(pages)[0]));
    }
    setTimeout(() => {
      dispatch(centerViewbox());
      dispatch(createSnapshotThunk());
      if (pages && Object.keys(pages)?.length) {
        const { page } = getAllLayers(pagesSelection[0], pages);
        if (page.sections) {
          const sections = Object.values(page.sections).sort(
            (a, b) => a.x - b.x
          );
          if (sections?.length) {
            const { group } = getAllLayers(sections[0].shieldId, pages);
            if (group) {
              const { shields } = group;
              dispatch(handleShapeClick(shields[sections[0].shieldId]));
            }
            dispatch(handleSectionClick({ section: sections[0] }));
          }
        }
      }
    }, 0);
  };

  const onNextClick = () => {
    setCurrentPage(currentPage + 1);
  };

  const onBackClick = () => {
    setCurrentPage(currentPage > 0 ? currentPage - 1 : 0);
  };

  const wizards = [
    {
      id: 'app.editor.wizard.patch_panel-wizard',
      name: 'Patch Panel',
      key: 'PATCH_PANEL',
      disabled: false,
      image: 'patch-panel-wizard.svg',
    },
    {
      id: 'app.editor.wizard.product_terminal-block',
      name: 'Terminal Block',
      key: 'TERMINAL_BLOCK',
      disabled: true,
      image: 'terminal-block-wizard.svg',
    },
    {
      id: 'app.editor.wizard.product_cable-wrap',
      name: 'Cable wrap',
      key: 'CABLE_WRAP',
      disabled: true,
      image: 'cable-wrap-wizard.svg',
    },
    {
      id: 'app.editor.wizard.product_cable-flag',
      name: 'Cable Flag',
      key: 'CABLE_FLAG',
      disabled: false,
      image: 'cable-flag-wizard.svg',
    },
  ];
  const preselectedIndex = crossSectionAreas.findIndex(
    element => element.value === flagMidLength
  );
  const preselectedSrossSelectedSection =
    preselectedIndex > -1 ? preselectedIndex : 0;
  const [crossSelectedSection, setCrossSelectedSection] = useState(
    crossSectionAreas[preselectedSrossSelectedSection]
  );
  const _title =
    wizards?.find(w => w.key === selWizard?.application_type)?.id ||
    selWizard?.application_type;
  const title = <FormattedMessage id={_title} defaultMessage="Wizard" />;

  return (
    <WizardPageWrapper id="renderer-svg" $isLastWizardPage={isLastWizardPage}>
      <Header>
        <WizardHeader title={title || 'WIZARD'} />
      </Header>
      <RendererWrapper>
        {selWizard?.application_type === 'CABLE_FLAG' && (
          <CableFlagWizard
            userSizeUnit={userSizeUnit}
            isDesktop={isDesktop}
            isSmartphone={isSmartphone}
            targetDevice={targetDevice}
            cableDiameter={cableDiameter}
            flagLength={flagLength}
            onCableDiameterChangeClb={onCableDiameterChangeClb}
            onFlagLengthChangeClb={onFlagLengthChangeClb}
            slaveAngle={slaveAngle}
            setSlaveAngle={setSlaveAngle}
            isCableFlagSync={isCableFlagSync}
            isLastWizardPage={isLastWizardPage}
            withMiddleLine={withMiddleLine}
            setWithMiddleLine={setWithMiddleLine}
            lineType={lineType}
            setLineType={setLineType}
            lineThickness={lineThickness}
            onLineThicknessChangeClb={onLineThicknessChangeClb}
            isDimesionTypeDiameter={isDimesionTypeDiameter}
            setIsDimesionTypeDiameter={setIsDimesionTypeDiameter}
            isFlagLengthAuto={isFlagLengthAuto}
            setIsFlagLengthAuto={setIsFlagLengthAuto}
            textOrientation={textOrientation}
            setTextOrientation={setTextOrientation}
            crossSectionAreas={crossSectionAreas}
            crossSelectedSection={crossSelectedSection}
            setCrossSelectedSection={setCrossSelectedSection}
            setCableDiameterByArea={setCableDiameterByArea}
            setIsCableFlagSyncState={setIsCableFlagSyncState}
            setIsCableFlagSync={setIsCableFlagSync}
            setFlagMidLength={setFlagMidLength}
          />
        )}
        <div></div>
      </RendererWrapper>
      <Footer $isLastWizardPage={isLastWizardPage}>
        <WizardFooter
          currentPage={currentPage}
          onNextClick={currentPage > 0 ? onEditorClick : onNextClick}
          onBackClick={onBackClick}
          onSaveClick={onSaveClick}
          isLastWizardPage={isLastWizardPage}
          isSmartphone={isSmartphone}
        />
      </Footer>
    </WizardPageWrapper>
  );
};

export default React.memo(WizardModePage);
